import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { clearReservations, fetchReservation } from './actions';
import ReservationCanceled from './components/ReservationCanceled';
import {
  getAppointment,
  getBarberName,
  getServiceName,
  getShop,
  getCustomer,
  getRebookLink,
  getScheduleLink,
} from './selectors';

const mapStateToProps = (state, ownProps) => ({
  appointment: getAppointment(state),
  barberName: getBarberName(state),
  serviceName: getServiceName(state),
  shop: getShop(state),
  customer: getCustomer(state),
  rebookLink: getRebookLink(state),
  scheduleLink: getScheduleLink(state),
  appointmentId: ownProps.params.appointmentId,
});

const mapDispatchToProps = ({
  fetchReservation,
  clearReservations,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    fetchReservation: props => () => props.fetchReservation(props.appointmentId),
  }),
  lifecycle({
    componentWillMount() {
      this.props.fetchReservation();
    },
    componentWillUnmount() {
      this.props.clearReservations();
    },
  })
)(ReservationCanceled);



// WEBPACK FOOTER //
// ./src/app/reservation/ReservationCanceled.jsx